import { render, staticRenderFns } from "./materialList.vue?vue&type=template&id=58bd7568&scoped=true&"
import script from "./materialList.vue?vue&type=script&lang=js&"
export * from "./materialList.vue?vue&type=script&lang=js&"
import style0 from "./materialList.vue?vue&type=style&index=0&id=58bd7568&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bd7568",
  null
  
)

export default component.exports